<template>
  <ItemsQuestion
    v-if="parkOffersCoworking"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'CoworkingProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersCoworking) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersCoworking () {
        return ParkPrograms.has(ParkPrograms.COWORKING, this.quizAnswers)
      }
    },
    watch: {
      parkOffersCoworking: {
        immediate: true,
        handler () {
          if (!this.parkOffersCoworking) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CoworkingProgramItemsQuestion.vue?69820211